/* eslint-disable max-len */
import { ofType } from 'redux-observable';
import {
  catchError, debounceTime, filter, from, map, mergeMap, Observable, of, takeUntil,
} from 'rxjs';
import Config from '../../../Common/Config';
import {
  clearExpenseNotification,
  clearExpenseNotificationFailure,
  clearExpenseNotificationSuccess,
  DashBoardActions, getAnalystTubeCountReport, getAnalystTubeCountReportFailure, getAnalystTubeCountReportSuccess,
  getBidReportList,
  getBidReportListFailure,
  getBidReportListSuccess,
  getDashboardData, getDashboardDataFailure, getDashboardDataSuccess,
  getExpenseNotifications,
  getExpenseNotificationsFailure,
  getExpenseNotificationsSuccess,
  getFoNotifications,
  getFoNotificationsFailure,
  getFoNotificationsSuccess,
  getFOUsersList,
  getFOUsersListFailure,
  getFOUsersListSuccess,
  getMorningReport,
  getMorningReportFailure,
  getMorningReportPdf,
  getMorningReportPdfFailure,
  getMorningReportPdfSuccess,
  getMorningReportSuccess,
  getNotifications,
  getNotificationsFailure,
  getNotificationsSuccess,
  getSyncDownReport,
  getSyncDownReportFailure,
  getSyncDownReportSuccess,
  removeMorningReport,
  removeMorningReportFailure,
  removeMorningReportSuccess,
} from './dashboardSlice';
import { makeGetRequest, makeGetRequestWithParams, makePostRequest } from '../../../Common/NetworkOps';
import {
  AnalystTubeCountPayload,
  GetAnalystReportApiResponse, GetBidReportListApiResponse, GetDashboardApiResponse, GetDashboardPayload, GetExpenseNotificationsApiResponse, GetFOUsersApiResponse, GetMorningReportApiResponse,
  GetMorningReportPdfApiResponse,
  GetNotificationsApiResponse,
  GetSyncDownApiResponse,
} from '../utils/TypeDashboard';
import { showErrorToaster, showGreenInfo10Toaster } from '../../../Common/ComponentToast/ComponentSuccessToasts';

async function getDashBoardData(data: GetDashboardPayload): Promise<GetDashboardApiResponse> {
  const { type, fromDate, toDate } = data;
  const url = `${Config.dashboard.GetallInfo}?FromDate=${fromDate}&ToDate=${toDate}&Type=${type}`;
  const result = await makeGetRequest<GetDashboardApiResponse>(url);
  return result.data;
}

export const getDashboardEpic = (action$ : Observable<DashBoardActions>) => action$.pipe(
  ofType(getDashboardData.type),
  debounceTime(250),
  map((x) => x.payload),
  mergeMap((data: GetDashboardPayload) => from(getDashBoardData(data)).pipe(
    map((res: GetDashboardApiResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return getDashboardDataSuccess(res.BMT.Result);
      }
      return getDashboardDataSuccess(res.BMT.Result);
    }),
    takeUntil(action$.pipe(filter(getDashboardData.match))),
    catchError((error) => of(getDashboardDataFailure(error))),
  )),
);

async function getMorningReportAPI(): Promise<GetMorningReportApiResponse> {
  const url = `${Config.dashboard.GetMorningReport}?PageSize=300&PageNumber=1`;
  const result = await makeGetRequest<GetMorningReportApiResponse>(url);
  return result.data;
}

export const getMorningReportEpic = (action$ : Observable<DashBoardActions>) => action$.pipe(
  ofType(getMorningReport.type),
  debounceTime(250),
  map((x) => x.payload),
  mergeMap(() => from(getMorningReportAPI()).pipe(
    map((res: GetMorningReportApiResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return getMorningReportSuccess(res.BMT.Result);
      }
      return getMorningReportFailure(res.BMT.ResponseMessage);
    }),
    takeUntil(action$.pipe(filter(getMorningReport.match))),
    catchError((error) => of(getMorningReportFailure(error))),
  )),
);
async function getMorningReportPdfAPI(data: object): Promise<GetMorningReportPdfApiResponse> {
  const url = `${Config.dashboard.GetMorningReportPdf}`;
  const result = await makePostRequest<GetMorningReportPdfApiResponse>(url, data);
  return result.data;
}

export const getMorningReportPdfEpic = (action$ : Observable<DashBoardActions>) => action$.pipe(
  ofType(getMorningReportPdf.type),
  debounceTime(250),
  map((x) => x.payload),
  mergeMap((data) => from(getMorningReportPdfAPI(data)).pipe(
    map((res: GetMorningReportPdfApiResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return getMorningReportPdfSuccess(res.BMT.Result);
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return getMorningReportPdfFailure(res.BMT.ResponseMessage);
    }),
    takeUntil(action$.pipe(filter(getMorningReportPdf.match))),
    catchError((error) => {
      showErrorToaster(error?.response?.data?.BMT?.ResponseMessage);
      return of(getMorningReportPdfFailure(error));
    }),
  )),
);
async function removeReportAPI(data: object): Promise<GetMorningReportPdfApiResponse> {
  const url = `${Config.dashboard.RemoveMorningReport}`;
  const result = await makePostRequest<GetMorningReportPdfApiResponse>(url, data);
  return result.data;
}

export const removeReportEpic = (action$ : Observable<DashBoardActions>) => action$.pipe(
  ofType(removeMorningReport.type),
  debounceTime(250),
  map((x) => x.payload),
  mergeMap((data) => from(removeReportAPI(data)).pipe(
    map((res: GetMorningReportPdfApiResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return removeMorningReportSuccess();
      }
      return removeMorningReportFailure(res.BMT.ResponseMessage);
    }),
    takeUntil(action$.pipe(filter(removeMorningReport.match))),
    catchError((error) => of(removeMorningReportFailure(error))),
  )),
);

async function getAnalystTubeCountReportAPI(data: AnalystTubeCountPayload): Promise<GetAnalystReportApiResponse> {
  const url = Config.dashboard.GetAnalystTubeReport;
  const result = await makePostRequest<GetAnalystReportApiResponse>(url, data);
  return result.data;
}

export const getAnalystTubeCountReportEpic = (action$ : Observable<DashBoardActions>) => action$.pipe(
  ofType(getAnalystTubeCountReport.type),
  debounceTime(250),
  map((x) => x.payload),
  mergeMap((data: { pay: AnalystTubeCountPayload, callback: () => void }) => from(getAnalystTubeCountReportAPI(data.pay)).pipe(
    map((res: GetAnalystReportApiResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        data.callback();
        showGreenInfo10Toaster(`The Analyst Tube Count Report is in the process of being generated. The completed report will be delivered to ${data.pay.Email} within the next hour.`);
        return getAnalystTubeCountReportSuccess();
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return getAnalystTubeCountReportFailure(res.BMT.ResponseMessage);
    }),
    takeUntil(action$.pipe(filter(getAnalystTubeCountReport.match))),
    catchError((error) => {
      showErrorToaster(error?.response?.data?.BMT?.ResponseMessage);
      return of(getAnalystTubeCountReportFailure(error));
    }),
  )),
);

async function getSyncDownReportAPI(): Promise<GetSyncDownApiResponse> {
  const url = Config.dashboard.GetSyncDownReport;
  const result = await makeGetRequest<GetSyncDownApiResponse>(url);
  return result.data;
}

export const getSyncDownReportEpic = (action$ : Observable<DashBoardActions>) => action$.pipe(
  ofType(getSyncDownReport.type),
  debounceTime(250),
  map((x) => x.payload),
  mergeMap(() => from(getSyncDownReportAPI()).pipe(
    map((res: GetSyncDownApiResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return getSyncDownReportSuccess(res.BMT.Result);
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return getSyncDownReportFailure(res.BMT.ResponseMessage);
    }),
    takeUntil(action$.pipe(filter(getSyncDownReport.match))),
    catchError((error) => {
      showErrorToaster(error?.response?.data?.BMT?.ResponseMessage);
      return of(getSyncDownReportFailure(error));
    }),
  )),
);

async function getExpenseNotificationsAPI(data: object): Promise<GetExpenseNotificationsApiResponse> {
  const url = Config.dashboard.GetExpenseNotification;
  const result = await makeGetRequestWithParams<GetExpenseNotificationsApiResponse>(url, data);
  return result.data;
}

export const getExpenseNotificationsEpic = (action$ : Observable<DashBoardActions>) => action$.pipe(
  ofType(getExpenseNotifications.type),
  debounceTime(250),
  map((x) => x.payload),
  mergeMap((data: object) => from(getExpenseNotificationsAPI(data)).pipe(
    map((res: GetExpenseNotificationsApiResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return getExpenseNotificationsSuccess(res.BMT.Result);
      }
      return getExpenseNotificationsFailure(res.BMT.ResponseMessage);
    }),
    takeUntil(action$.pipe(filter(getExpenseNotifications.match))),
    catchError((error) => of(getExpenseNotificationsFailure(error))),
  )),
);

async function getNotificationsAPI(data: object): Promise<GetNotificationsApiResponse> {
  const url = Config.dashboard.GetNotification;
  const result = await makeGetRequestWithParams<GetNotificationsApiResponse>(url, data);
  return result.data;
}

export const getNotificationsEpic = (action$ : Observable<DashBoardActions>) => action$.pipe(
  ofType(getNotifications.type),
  debounceTime(250),
  map((x) => x.payload),
  mergeMap((data: object) => from(getNotificationsAPI(data)).pipe(
    map((res: GetNotificationsApiResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return getNotificationsSuccess(res.BMT.Result);
      }
      return getNotificationsFailure(res.BMT.ResponseMessage);
    }),
    takeUntil(action$.pipe(filter(getNotifications.match))),
    catchError((error) => of(getNotificationsFailure(error))),
  )),
);
async function getFoNotificationsAPI(data: object): Promise<GetNotificationsApiResponse> {
  const url = Config.dashboard.GetNotification;
  const result = await makeGetRequestWithParams<GetNotificationsApiResponse>(url, data);
  return result.data;
}

export const getFoNotificationsEpic = (action$ : Observable<DashBoardActions>) => action$.pipe(
  ofType(getFoNotifications.type),
  debounceTime(250),
  map((x) => x.payload),
  mergeMap((data: object) => from(getFoNotificationsAPI(data)).pipe(
    map((res: GetNotificationsApiResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return getFoNotificationsSuccess(res.BMT.Result);
      }
      return getFoNotificationsFailure(res.BMT.ResponseMessage);
    }),
    takeUntil(action$.pipe(filter(getFoNotifications.match))),
    catchError((error) => of(getFoNotificationsFailure(error))),
  )),
);

async function clearExpenseNotificationAPI(data: object): Promise<GetExpenseNotificationsApiResponse> {
  const url = Config.dashboard.ClearExpenseNotification;
  const result = await makeGetRequestWithParams<GetExpenseNotificationsApiResponse>(url, data);
  return result.data;
}

export const clearExpenseNotificationEpic = (action$ : Observable<DashBoardActions>) => action$.pipe(
  ofType(clearExpenseNotification.type),
  debounceTime(250),
  map((x) => x.payload),
  mergeMap((data: object) => from(clearExpenseNotificationAPI(data)).pipe(
    map((res: GetExpenseNotificationsApiResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return clearExpenseNotificationSuccess();
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return clearExpenseNotificationFailure(res.BMT.ResponseMessage);
    }),
    takeUntil(action$.pipe(filter(clearExpenseNotification.match))),
    catchError((error) => {
      showErrorToaster(error?.response?.data?.BMT?.ResponseMessage);
      return of(clearExpenseNotificationFailure(error));
    }),
  )),
);
async function getFOUsersListAPI(): Promise<GetFOUsersApiResponse> {
  const url = Config.dashboard.GetFOUsers;
  const result = await makeGetRequest<GetFOUsersApiResponse>(url);
  return result.data;
}

export const getFOUsersListEpic = (action$ : Observable<DashBoardActions>) => action$.pipe(
  ofType(getFOUsersList.type),
  debounceTime(250),
  map((x) => x.payload),
  mergeMap(() => from(getFOUsersListAPI()).pipe(
    map((res: GetFOUsersApiResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return getFOUsersListSuccess(res.BMT.Result);
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return getFOUsersListFailure(res.BMT.ResponseMessage);
    }),
    takeUntil(action$.pipe(filter(getFOUsersList.match))),
    catchError((error) => {
      showErrorToaster(error?.response?.data?.BMT?.ResponseMessage);
      return of(getFOUsersListFailure(error));
    }),
  )),
);
async function getBidReportListAPI(data: object): Promise<GetBidReportListApiResponse> {
  const url = Config.dashboard.GetBidReportList;
  const result = await makeGetRequestWithParams<GetBidReportListApiResponse>(url, data);
  return result.data;
}

export const getBidReportListEpic = (action$ : Observable<DashBoardActions>) => action$.pipe(
  ofType(getBidReportList.type),
  debounceTime(250),
  map((x) => x.payload),
  mergeMap((data: object) => from(getBidReportListAPI(data)).pipe(
    map((res: GetBidReportListApiResponse) => {
      if (res.BMT.ResponseCode === Config.SUCCESS_CODE) {
        return getBidReportListSuccess(res.BMT.Result);
      }
      showErrorToaster(res.BMT.ResponseMessage);
      return getBidReportListFailure(res.BMT.ResponseMessage);
    }),
    takeUntil(action$.pipe(filter(getBidReportList.match))),
    catchError((error) => {
      showErrorToaster(error?.response?.data?.BMT?.ResponseMessage);
      return of(getBidReportListFailure(error));
    }),
  )),
);
